<style></style>
<template>
  <div style="padding-bottom: 1px" class="element-wrapper text-dark">
    <div class="element-actions actions-only"></div>
    <table class="table table-compact smaller mb-0">
      <thead>
        <tr class="text-success">
          <th>Tienda</th>
          <!--th class="text-center">Date</th-->
          <th class="text-center">S</th>
          <th class="text-center">C</th>
          <th class="text-center">V</th>
          <th class="text-right">Min</th>
          <th class="text-right">Max</th>
          <th class="text-right">Stock</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="current_stock in tiendasfiltradas" v-bind:key="current_stock.id">
          <td>
            <span>{{ current_stock.tienda }}</span>
          </td>
          <td class="text-center text-bright">
            <i
              v-if="current_stock.sol_auto == false"
              class="fas fa-square text-danger"
            ></i>
            <i
              v-if="current_stock.sol_auto == true"
              class="fas fa-square text-success"
            ></i>
          </td>

          <td class="text-center text-bright">
            <i
              v-if="current_stock.permitir_compras == false"
              class="fas fa-square text-danger"
            ></i>
            <i
              v-if="current_stock.permitir_compras == true"
              class="fas fa-square text-success"
            ></i>
          </td>
          <td class="text-center text-bright">
            <i
              v-if="current_stock.permitir_ventas == false"
              class="fas fa-square text-danger"
            ></i>
            <i
              v-if="current_stock.permitir_ventas == true"
              class="fas fa-square text-success"
            ></i>
          </td>
          <td class="text-right text-dark">{{ current_stock.minimo }}</td>

          <td class="text-right text-dark">{{ current_stock.maximo }}</td>
          <td class="text-right">
            <a
              @click="actualizarExistreciasporTienda(current_stock)"
              class="text-right text-success"
              :class="{
                'text-danger': current_stock.existencia <= current_stock.minimo,
                'text-warning': current_stock.existencia > current_stock.maximo,
              }"
              >{{ current_stock.existencia }}</a
            >
          </td>
          <!--td>
                        <button class="btn btn-sm btn-warning">Editar</button>
            </td-->
        </tr>
      </tbody>
    </table>
    <br />
    <table class="mx-auto" style="font-size: 10px;">
      <tr>
        <td style="padding: 2px;" class="text-left">S:</td>
        <td style="padding: 2px" class="text-left">Solicitud auto, &nbsp;</td>
        <td style="padding: 2px" class="text-left">C:</td>
        <td style="padding: 2px" class="text-left">Compras,  &nbsp;</td>
        <td style="padding: 2px" class="text-left">V:</td>
        <td style="padding: 2px" class="text-left">Ventas</td>
      </tr>
    </table>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {},
  data() {
    return {
      datos: {
        tiendas: [],
      },
    };
  },
  props: {
    current: {
      type: Object,
      required: true,
    },
    filtrartienda: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    tiendasfiltradas() {
      let self = this;
      if (self.current.productotienda_set) {
        return self.current.productotienda_set.filter((t) => {
          return self.filtrartienda == null || t.tienda == self.filtrartienda;
        });
      }
      return [];
    },
  },
  mounted() {},
  methods: {
    actualizarExistreciasporTienda(current_stock) {
      DynamicService.getAction(
        "cat",
        "productos",
        current_stock.producto,
        "actualizar_existencia_x_tienda",
        {
          tienda_id: current_stock.tienda,
        }
      )
        .then((response) => {
          this.refresh();
        })
        .catch((error) => {
          alert("ERROR, No se actualizo la existencia, consulte al area de sistemas");
        });
    },
    refresh() {
      this.$emit("refresh");
    },
  },
};
</script>
